import * as React from 'react';
import { SVGProps } from 'react';

const SvgReset = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.36 10.295h6.147L7.023 7.738c2.475-2.448 6.483-2.539 8.958-.091a6.244 6.244 0 0 1 0 8.885c-2.475 2.448-6.483 2.448-8.958 0-1.233-1.224-1.85-2.648-1.85-4.443H3.36c0 1.795.798 4.125 2.394 5.703 3.182 3.155 8.351 3.155 11.533 0 3.173-3.146 3.201-8.26.018-11.406s-8.287-3.146-11.469 0L3.361 3.838v6.456z" />
  </svg>
);

export default SvgReset;
